import { useState } from 'react'
import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import {} from '@factorialco/f0-react/icons/app'
import {
  ProjectManagementProjectDetailsPageProjectTasksPageDocument,
  ProjectManagementProjectDetailsPageQuery,
  ProjectTaskAnalyticsDocument,
  ProjectTasksDataCollectionDocument,
} from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import ProjectTasksDataCollection from 'modules/project_management/components/tables/ProjectTasksDataCollection'
import { UpsellProjectsTasks } from 'modules/project_management/components/upsells/UpsellProjectsTasks'
import { AddTaskWizard } from 'modules/project_management/components/wizards/AddTaskWizard'

const ProjectTasksPage = () => {
  const { id: projectId } = useParams()

  const { data: pageData } = useQuery(ProjectManagementProjectDetailsPageProjectTasksPageDocument, {
    variables: {
      projectId: String(projectId),
    },
  })

  const hasProjectWorkers =
    (pageData?.projectManagement?.projectWorkersConnection?.totalCount ?? 0) > 0

  const { hasProjectTasks, hasExpenses, hasFlexibleTracking, project } = useOutletContext<{
    hasProjectTasks: boolean
    hasExpenses: boolean
    hasFlexibleTracking: boolean
    project: NonNullable<
      ProjectManagementProjectDetailsPageQuery['projectManagement']['projectsConnection']['nodes'][0]
    >
  }>()

  const canManageTasks = pageData?.projectManagement?.project?._policies?.manageTasks?.can ?? false
  const hasTimeTrackingSection =
    pageData?.attendance._policies.sidebarSeeAttendanceCompanyTopLevelItem.can ?? false

  const canExportData =
    canManageTasks && (hasTimeTrackingSection || hasExpenses || hasFlexibleTracking)

  useEffect(() => {
    track(trackingEvents.projectManagement.tasks.visitProjectTasks)
  }, [])

  const [isWizardOpen, setIsWizardOpen] = useState(false)
  const [taskStatusCreation, setTaskStatusCreation] = useState<string>('')

  if (!hasProjectTasks) {
    return <UpsellProjectsTasks />
  }

  return (
    <Box paddingBottom="s0">
      <ProjectTasksDataCollection
        projectId={project.id}
        projectName={project.name}
        canManageTasks={canManageTasks}
        canExportData={canExportData}
        onClickCreateTask={(newStatus) => {
          setIsWizardOpen(true)
          setTaskStatusCreation(newStatus ?? '')
        }}
      />

      {isWizardOpen && (
        <AddTaskWizard
          hasProjectWorkers={hasProjectWorkers}
          onClose={() => {
            setIsWizardOpen(false)
            setTaskStatusCreation('')
          }}
          refetchQueries={[ProjectTaskAnalyticsDocument, ProjectTasksDataCollectionDocument]}
          taskStatus={taskStatusCreation}
        />
      )}
      <Outlet context={{ hasExpenses, hasFlexibleTracking }} />
    </Box>
  )
}

export default ProjectTasksPage
